// extracted by mini-css-extract-plugin
module.exports = {"btn":"ProductDetailsButton_btn__1ezgK"};